import { asc, eq } from "drizzle-orm";
import { attachment, type PowerSyncDrizzleDB } from "@cashsync/powersync";

/** Attachments (receipts) for a transaction, from oldest to newest. */
export function getAttachmentsByTxQuery(db: PowerSyncDrizzleDB, txId: string) {
  return db
    .select()
    .from(attachment)
    .where(eq(attachment.tx_id, txId))
    .orderBy(asc(attachment.created_at));
}
